// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/styles/index.scss'
import i18n from '@/utils/i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill';
import animated from 'animate.css' // npm install animate.css --save安装，在引入

Vue.use(animated)
Vue.config.productionTip = false;

//交互axios
import axios from 'axios';
axios.defaults.withCredentials = true; //携带凭证
// Vue.prototype.axios = axios; //原型绑定axios

import HttpService from './service/HttpService'; //引入axios配置
Vue.prototype.$http = HttpService; //原型绑定
Vue.prototype.oAssets = process.env.BASE_IMG;

//状态管理
import store from './store';

Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
    // console.log(to.query);
    if (to.query.buyVip === "true") {
        Vue.prototype.buyVip = true;
    } else {
        Vue.prototype.buyVip = false;
    }
    Vue.prototype.schoolId = to.query.schoolId;
    next()
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n,
    router,
    components: {
        App
    },
    template: '<App/>',
    store,
})


// WEBPACK FOOTER //
// ./src/main.js